import React from "react";
import { getPricingBands, formatBandBalance } from "../../utils/pricingBands";

export const PricingDetails = ({ merchant, balance, invalidBalance }) => {
  if (!merchant) return null;
  const bands = getPricingBands(merchant);
  const value = Number(balance);
  const applicable =
    !invalidBalance && String(balance).trim() && Number.isFinite(value)
      ? bands.find(
          (band) =>
            value >= band.min &&
            (value < band.max || (band.maxInclusive && value === band.max))
        )
      : null;

  return (
    <div style={{ margin: "12px 10px 0", fontSize: 13 }}>
      <div aria-live="polite">
        {applicable && (
          <p style={{ marginBottom: 8 }}>
            Payout: <strong>{applicable.percentage}%</strong>
          </p>
        )}
      </div>
      {bands.length > 1 && (
        <details key={merchant.id}>
          <summary style={{ cursor: "pointer" }}>View payouts</summary>
          <table style={{ width: "100%", maxWidth: 500, marginTop: 8 }}>
            <caption style={{ textAlign: "left" }}>{merchant.name}</caption>
            <thead>
              <tr>
                <th scope="col">Card Balance</th>
                <th scope="col">Payout (%)</th>
              </tr>
            </thead>
            <tbody>
              {bands.map((band) => (
                <tr key={`${band.min}-${band.max}`}>
                  <td>{formatBandBalance(band)}</td>
                  <td>{band.percentage}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </details>
      )}
    </div>
  );
};
